import React, {Component} from 'react';
import {withRouter, Route} from 'react-router-dom';
import {connect} from 'react-redux';
import ReactSwipe from 'react-swipe';
import { withTranslation, withNamespaces } from "react-i18next";
import LoginComponent from '../../Containers/Authentication';

// utils
import * as Const from '../../Data/const'


// styles
import style from '../../Styles/Containers/Help.module.css'


class HelpContainer extends Component{
  constructor() {
    super();
    this.swiper = null;
    this.state={
      activeIndex: 0,
      swipeContent: [],
      isLoginVisible: false,
    }

    this.closeActivity = this.closeActivity.bind(this);
  }

  componentDidMount(){
    const winHeight = window.innerHeight;
    const winWidth = window.innerWidth;
    const { t } = this.props;

    this.setState({
      swipeContent: 
      [
        <div className={style.background} style={{height: winHeight, width: winWidth}}>
          <img className={style.background} style={{height: winHeight, width: winWidth}} 
          src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/img-help-01.png"} 
          srcSet="https://d15eixcc3515pq.cloudfront.net/Assets/img/img-help-01@2x.png 2x, https://d15eixcc3515pq.cloudfront.net/Assets/img/img-help-01@3x.png 3x"/>
          <div className={style.skip} onClick={this.closeActivity}>SKIP</div>
          <div className={[style.font, style.font_flash].join(' ')} >
            {/*어두운 곳에서는<br></br>플래시를 밝히세요.*/}
            {t('turn_on_light')}
          </div>
          <div className={[style.font, style.font_qr].join(' ')} >
            {/*QR코드를 스캔하거나 NFC모드로<br></br>태그하여 정품을 인증하세요.*/}
            {t('scan_qr_or_tag_nfc')}
          </div>
          <div className={[style.font, style.font_ar].join(' ')} >
            {/*AR 스캔을 통해 제품의<br></br>3D 모델링을 확인 할 수 있어요!*/}
            {t('check_3d_modeling')}
          </div>
        </div>
        ,
        <div className={style.background} style={{height: winHeight, width: winWidth}}>
          <img className={style.background} style={{height: winHeight, width: winWidth}}
          src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/img-help-02.png"}
          srcSet="https://d15eixcc3515pq.cloudfront.net/Assets/img/img-help-02@2x.png 2x, https://d15eixcc3515pq.cloudfront.net/Assets/img/img-help-02@3x.png 3x"/>
          <div className={style.skip} onClick={this.closeActivity}>SKIP</div>
          <div className={[style.font, style.font_brand].join(' ')}>
            {/*인증결과를 통해서 제품 브랜드 정보와<br></br>상세정보를 확인 할 수 있어요!*/}
            {t('check_through_authentication')}
          </div>
          <div className={[style.font, style.font_auth].join(' ')} >
            {/*내가 첫 인증자인지<br></br>인증횟수를 통해서 확인하세요!*/}
            {t('check_first_authentication')}
          </div>
          <div className={[style.font, style.font_route].join(' ')} >
            {/*어떤 경로로 이 제품을<br></br>유통했는지 확인 할 수 있어요.*/}
            {t('check_the_way_distributed')}
          </div>
          <div className={[style.font, style.font_scroll].join(' ')} >
            {/*스크롤을 내려서 제품 상세정보를<br></br>확인 할 수 있어요!*/}
            {t('scroll_to_check_detail')}
          </div>
        </div>
        ,
        <div className={style.background} style={{height: winHeight, width: winWidth}}>
          <img className={style.background} style={{height: winHeight, width: winWidth}} 
          src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/img-help-03.png"}
          srcSet="https://d15eixcc3515pq.cloudfront.net/Assets/img/img-help-03@2x.png 2x, https://d15eixcc3515pq.cloudfront.net/Assets/img/img-help-03@3x.png 3x"/>
          <div className={[style.skip, style.skip_black].join(' ')} onClick={this.closeActivity}>SKIP</div>
          <div className={style.font_last} >
            {/*정품인증한 브랜드에서<br></br>진행중인 이벤트에 참가하고<br></br><span className={style.font_last_point}>특별한 혜택</span>을 받아가세요!*/}
            {t('participate_for_benefit')}
          </div>
          <div className={style.submit_button} onClick={() => this.setState({ isLoginVisible: true })}>{t('log_in')}</div>
          <div className={style.font_join} onClick={() => this.setState({ isLoginVisible: true })}>{t('register')}</div>
        </div>
      ]
    })
  }

  get swipeDot(){
    return this.state.swipeContent.map((item,index)=> 
    index === this.state.activeIndex ? 
      <div key={index} className={style.swiperNavigationActiveDot}></div>
      :
      <div key={index} className={style.swiperNavigationDot}></div>
    )
  }

  closeActivity() {
    Const.userAppCloseActivity();
  }

  render(){
    
    const swipeOptions={ 
      continuous: false,
      callback: (index,element)=>{
      },
      transitionEnd:(index,element)=>{
        this.setState({
          activeIndex: index
        }, ()=>{
          this.swiper.slide(index);
        })
      }
    }
    return(
      <div className={style.container} style={{height: window.innerHeight}}>
        <ReactSwipe
          ref={(ref)=> {this.swiper = ref}}
          swipeOptions={{ 
            continuous: false,
            callback: (index,element)=>{
            },
            transitionEnd:(index,element)=>{
              this.setState({
                activeIndex: index
              }, ()=>{
                this.swiper.slide(index);
              })
            }
          }}
          >
          {this.state.swipeContent}
        </ReactSwipe>
        <div className={style.swiperNavigation}>
          {this.state.activeIndex < this.state.swipeContent.length - 1 && this.swipeDot}
        </div>
        {this.state.isLoginVisible ? <LoginComponent onRef={(ref) => { this.loginRef = ref;}} handleClose={() => this.setState({ isLoginVisible: false })}
                                                     modalContents={{title: this.props.t('sns_login'), info: this.props.t('login_required_for_event')}}/> : null}
      </div>
    )
  }
}

export default connect()(withRouter(withTranslation()(HelpContainer)));